import { createTheme } from '@mui/material/styles';

const customTheme = createTheme({
  palette: {
    primary: {
      main: '#00555C', // Your primary color
      light: '#63a4ff', // Optional
      dark: '#004ba0',  // Optional
      contrastText: '#ffffff', // Optional
    },
    secondary: {
      main: '#9c27b0', // Your secondary color
      light: '#d05ce3', // Optional
      dark: '#6a0080',  // Optional
      contrastText: '#ffffff', // Optional
    },
    error: {
      main: '#f44336',
    },
    warning: {
      main: '#ffa726',
    },
    info: {
      main: '#2196f3',
    },
    success: {
      main: '#4caf50',
    },
    background: {
      default: '#f5f5f5', // Background color
      paper: '#ffffff', // Paper color
    },
    text: {
      primary: '#333333', // Primary text color
      secondary: '#555555', // Secondary text color
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Arial', sans-serif", // Custom font
  },
});

export default customTheme;
